import { Fragment, ReactNode } from "react";
import { FCX } from "@datassential/platform-ui-lib";
import cn from "classnames";
import "./CategoryProfileDataColumns.styles.scss";

export interface DataColumnItem {
    name: string;
    value: ReactNode;
}

export interface DataColumn {
    label: string;
    items: DataColumnItem[];
    testId?: string;
}

interface Props {
    columns: DataColumn[];
}

const CategoryProfileDataColumns: FCX<Props> = ({ columns, className }) => (
    <div className={cn("CategoryProfileDataColumns", className)}>
        {columns.map(({ label, items, testId }, index) => (
            <Fragment key={label}>
                <div className="CategoryProfileDataColumns__column" data-testid={testId}>
                    <div className="CategoryProfileDataColumns__column-header">
                        <span className="CategoryProfileDataColumns__column-label">{label}</span>
                        <span>Index</span>
                    </div>
                    <ul className="CategoryProfileDataColumns__items">
                        {items.map((item, itemIndex) => (
                            <li
                                key={`${label}-${item.name}-${itemIndex}`}
                                className="CategoryProfileDataColumns__item"
                            >
                                <span className="CategoryProfileDataColumns__item-name">
                                    {item.name}
                                </span>
                                <span className="CategoryProfileDataColumns__item-value">
                                    {item.value}
                                </span>
                            </li>
                        ))}
                    </ul>
                </div>
                {index < columns.length - 1 && (
                    <div className="CategoryProfileDataColumns__divider" />
                )}
            </Fragment>
        ))}
    </div>
);

export default CategoryProfileDataColumns;
